import React from 'react';
import {
  arrayOf,
  shape,
  string,
} from 'prop-types';
import { Heading } from 'components/common';
import SectionInfoColumn from './SectionInfoColumn';
import './AprFeesSection.scss';

const getFromPolicy = (policy, labels) => policy?.filter(pol => labels.includes(pol.type.key));

const AprFeesSection = ({
  fees,
  apr,
  policy,
  paymentNetwork,
  labels: {
    showMoreThreshold = {},
    heading,
    subHeadingFees,
    subHeadingOther,
    toggleLabels,
    subHeadingRepayment,
    subHeadingCancellation,
    otherInfoLabels,
  } = {},
}) => {
  const paymentNetworkCombine = paymentNetwork.length > 0 ? paymentNetwork.map(x => x.display).join(', ') : null;
  const cardCancelInfo = getFromPolicy(policy, ['MINIMUM_CARD_HOLDING_TIME', 'EARLY_CARD_CANCELLATION_PENALTY']);
  const otherInfo = getFromPolicy(policy, ['SUPPORTED_PAYMENT_TYPE']);
  otherInfo?.push({
    type: {
      display: otherInfoLabels.paymentNetwork,
      key: otherInfoLabels.paymentNetwork,
    },
    value: paymentNetworkCombine,
  });
  return (
    <div className="apr-fees-section">
      <div className="container-wrapper">
        <div className="row-wrapper">
          <div className="title">
            <Heading as="h2">
              {heading}
            </Heading>
          </div>
          <div className="content">
            <div className="row-wrapper">
              {fees && fees.length > 0 && (
                <div className="info-column-wrapper">
                  <SectionInfoColumn
                    title={subHeadingRepayment}
                    infoItems={fees}
                    toggleLabels={toggleLabels}
                    showMoreThreshold={showMoreThreshold.fees}
                  />
                </div>
              )}
              {apr && apr.length > 0 && (
                <div className="info-column-wrapper">
                  <SectionInfoColumn
                    title={subHeadingFees}
                    infoItems={apr}
                    toggleLabels={toggleLabels}
                    showMoreThreshold={showMoreThreshold.repayment}
                  />
                </div>
              )}
              {cardCancelInfo && cardCancelInfo.length > 0 && (
                <div className="info-column-wrapper">
                  <SectionInfoColumn
                    title={subHeadingCancellation}
                    infoItems={cardCancelInfo}
                    toggleLabels={toggleLabels}
                    showMoreThreshold={showMoreThreshold.cancellation}
                  />
                </div>
              )}
              {otherInfo && otherInfo.length > 0 && (
                <div className="info-column-wrapper">
                  <SectionInfoColumn
                    title={subHeadingOther}
                    infoItems={otherInfo}
                    toggleLabels={toggleLabels}
                    showMoreThreshold={showMoreThreshold.otherInfo}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AprFeesSection.defaultProps = {
  fees: null,
  apr: null,
  policy: [],
  labels: {},
  paymentNetwork: null,
};

AprFeesSection.propTypes = {
  fees: arrayOf(
    shape({
      name: string,
      value: string,
    })
  ),
  apr: arrayOf(
    shape({
      name: string,
      value: string,
    })
  ),
  policy: arrayOf(
    shape({
      name: string,
      value: string,
      description: shape({ shortDescription: string }),
    })
  ),
  paymentNetwork: arrayOf(shape({ key: string, display: string })),
  labels: shape({
    heading: string,
    subHeadingFees: string,
    subHeadingRepayment: string,
    subHeadingOther: string,
    subHeadingCancellation: string,
    otherInfoLabels: shape({}),
    toggleLabels: shape({
      showMore: string,
      showLess: string,
    }),
    showMoreThreshold: shape({}),
  }),
};

export default AprFeesSection;
